import {
  FileTextOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons'
import {
  Button,
  DatePicker,
  Form,
  Input,
  List,
  Spin,
  Tabs,
  Tooltip,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { EmptyText, UrlifiedText } from '../../components/Common/CellText'
import CounterCard from '../../components/CounterCard/CounterCard'
import EmptyContent from '../../components/EmptyContent'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent'
import { systemName, useSSO } from '../../config'
import {
  ACL_ACTION_TYPE,
  DD_MM,
  HHhMM,
  ISO_DATE_FORMAT,
  MODULE_CODE,
} from '../../constants'
import date_utils from '../../date_utils'
import DashboardLayout from '../../layouts/DashboardLayout'
import utils from '../../utils'
import validator from '../../validator'
import { LoginWrapper } from '../PortalPageV2/PortalPageV2Styled'
import {
  CardWrapper,
  DayTab,
  DescriptionLink,
  GeneralNotif,
  ItemCalendarContent,
  RowWrapper,
  WorkScheduledCard,
  WorkScheduledItem,
} from './DashboardPageV2Styled'
import './index.css'
import { WorkScheduleRequest } from '../../requests/WorkScheduleRequest'
import OfficeCalendar from '../CompanyWorkScheduleListPageV2/OfficeCalendar'

const { TabPane } = Tabs

const DashboardPageV2 = props => {
  const {
    history,
    location,

    statisticStore,
    fileStore,
    authenticationStore,
    accountStore,
    commandStore,
    notificationStore,
    userStore,
    moduleStore,
    aclStore,
    tintucStore,
    infoOptionStore,
  } = props
  const { infoOptions } = infoOptionStore
  const [linkMisbi, setLinkMisbi] = useState(null)
  const optionKey = 'MISBI_HOME'

  const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore
  const { aclActionsByUser } = aclStore

  // const { statistic } = statisticStore
  const { sideMenuCounter, dashboardSideMenuCounter } = commandStore
  const { newsList } = tintucStore

  // const [dataCongViec, setDataCongViec] = useState([{ type: '', value: 0 }])
  //

  const [isLoadingSidemenuCounter, setIsLoadingSidemenuCounter] = useState(
    false
  )
  const [isLoadingTinTuc, setIsLoadingTinTuc] = useState(false)
  //
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [, setShowDialog] = useState(false)

  const [selectedDate, setSelectedDate] = useState(
    moment().format(ISO_DATE_FORMAT)
  )
  const [isLoadingWorkSchedule, setIsLoadingWorkSchedule] = useState(false)
  const [weeklyWorkScheduleData, setWeeklyWorkScheduleData] = useState([])
  const [workScheduleListData, setWorkScheduledListData] = useState([])
  const [loadedWeekStart, setLoadedWeekStart] = useState(null)
  const [selectedEvent, setSelectedEvent] = useState(null)

  const handleGetWorkSchedule = useCallback(async () => {
    const startOfWeek = moment(selectedDate).startOf('isoWeek').format(ISO_DATE_FORMAT)
    const endOfWeek = moment(selectedDate).endOf('isoWeek').format(ISO_DATE_FORMAT)

    if (loadedWeekStart === startOfWeek) {
      const activeDayData = weeklyWorkScheduleData.filter(item =>
        moment(item.start_at).format(ISO_DATE_FORMAT) === selectedDate
      )
      setWorkScheduledListData(activeDayData)
      return
    }

    try {
      setIsLoadingWorkSchedule(true)
      const response = await WorkScheduleRequest.getWorkSchedule(
        startOfWeek,
        endOfWeek
      )

      const allData = response?.data || []
      setWeeklyWorkScheduleData(allData)
      setLoadedWeekStart(startOfWeek)

      const activeDayData = allData.filter(item =>
        moment(item.start_at).format(ISO_DATE_FORMAT) === selectedDate
      )
      setWorkScheduledListData(activeDayData)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
      setWeeklyWorkScheduleData([])
      setWorkScheduledListData([])
      setLoadedWeekStart(null)
    } finally {
      setIsLoadingWorkSchedule(false)
    }
  }, [selectedDate, loadedWeekStart, weeklyWorkScheduleData])

  useEffect(() => {
    handleGetWorkSchedule()
  }, [handleGetWorkSchedule])

  // useEffect(() => {
  //   ;(async () => {
  //     try {
  //       setIsLoadingSidemenuCounter(true)
  //       await Promise.all([
  //         commandStore.getSideMenuCounterDashboard(['WORK']),
  //         commandStore.getSideMenuCounterDashboard(['PROPOSAL']),
  //         commandStore.getSideMenuCounterDashboard(['INCOMING']),
  //         commandStore.getSideMenuCounterDashboard(['OUTGOING']),
  //         commandStore.getSideMenuCounterDashboard(['TASK']),
  //       ])
  //     } catch (err) {
  //       console.log(err)
  //       message.error(err.vi || 'Đã có lỗi xảy ra!')
  //     } finally {
  //       setIsLoadingSidemenuCounter(false)
  //     }
  //   })()
  // }, [])
  useEffect(() => {
    ; (async () => {
      const link = await infoOptionStore.load(optionKey)
      if (link && utils.validURL(link)) {
        setLinkMisbi(link)
      }
    })()
  }, [infoOptions])

  useEffect(() => {
    ; (async () => {
      try {
        setIsLoadingTinTuc(true)
        await tintucStore.getAllNews()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        setIsLoadingTinTuc(false)
      } finally {
        setIsLoadingTinTuc(false)
      }
    })()
  }, [])

  const isAccessControl = (moduleCode, accessControlType) => {
    if (isSuperAdmin) return true
    if (!moduleStore.checkAccessModule(moduleCode)) return false
    if (accessControlType)
      return (
        isAccountAdmin ||
        !!aclActionsByUser.find(item => item.code === accessControlType)?.status
      )
    return true
  }

  // clear workScheduleList va statistic khi ra khỏi trang dashboard
  useEffect(() => {
    return () => {
      statisticStore.clearStatistic()
      tintucStore.clear()
      commandStore.clearStore()
    }
  }, [])

  const onClickIncoming = () => {
    history.push({
      pathname: `/internal-document/incoming-document`,
      state: {
        from: location.pathname,
        onlyUnread: true,
        page: 0,
        size: 10,
      },
    })
  }
  const onClickOutgoing = () => {
    history.push({
      pathname: `/internal-document/outgoing-document`,
      state: {
        from: location.pathname,
        onlyUnread: true,
        page: 0,
        size: 10,
      },
    })
  }
  const onClickWorks = () => {
    history.push({
      pathname: `/works`,
      state: {
        from: location.pathname,
        isUnread: true,
      },
    })
  }
  const onClickMission = () => {
    history.push({
      pathname: `/mission`,
      state: {
        from: location.pathname,
      },
    })
  }
  const onClickProposal = () => {
    history.push({
      pathname: `/proposal`,
      state: {
        from: location.pathname,
        proposal_Status: 'PENDING',
      },
    })
  }

  const renderFile = file_ids => {
    if (file_ids) {
      if (file_ids.length === 0) {
        return <EmptyText>Không có tài liệu.</EmptyText>
      }
      if (file_ids.length === 1) {
        return (
          <DescriptionLink>
            <FileTextOutlined style={{ color: '#40a9ff' }} />
            <a
              onClick={e =>
                fileStore.handleDownloadFile(
                  file_ids[0].file_id,
                  file_ids[0].file_title
                )
              }>
              {file_ids[0].file_title}
            </a>
          </DescriptionLink>
        )
      }

      if (file_ids.length > 1) {
        return (
          <DescriptionLink>
            <FileTextOutlined style={{ color: '#40a9ff' }} />
            <a
              onClick={e =>
                fileStore.handleDownloadFile(
                  file_ids[0].file_id,
                  file_ids[0].file_title
                )
              }>
              {file_ids[0].file_title}
            </a>
          </DescriptionLink>
        )
      }
    }
  }

  const getShipScheduleContent = workScheduled => {
    const shipScheduleContent = []

    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Thời gian: </b>
        {workScheduled.end_at
          ? `Từ ${moment(workScheduled.start_at).format(HHhMM)} Đến ${moment(
            workScheduled.end_at
          ).format(HHhMM)}`
          : `Từ ${moment(workScheduled.start_at).format(HHhMM)}`}
      </div>
    )
    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Chủ trì: </b>
        {workScheduled.host ? (
          workScheduled.host
        ) : (
          <EmptyText>Không có chủ trì.</EmptyText>
        )}
      </div>
    )
    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Địa điểm: </b>
        <span>
          {workScheduled.location ? (
            UrlifiedText(workScheduled?.location)
          ) : (
            <EmptyText>Không có địa điểm.</EmptyText>
          )}
        </span>
      </div>
    )
    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Tài liệu: </b>
        <span>{renderFile(workScheduled?.file_ids)}</span>
      </div>
    )

    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Chuẩn bị: </b>
        <span>
          {workScheduled.preparation ? (
            workScheduled.preparation
          ) : (
            <EmptyText>Không có chuẩn bị.</EmptyText>
          )}
        </span>
      </div>
    )
    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Nội dung: </b>
        <div>
          {workScheduled.event_notice ? (
            UrlifiedText(
              workScheduled.event_notice
                .replace(/<\/?[^>]+(>|$)/g, '')
                .replace(/&nbsp;/g, '')
            )
          ) : (
            <EmptyText>Không có nội dung.</EmptyText>
          )}
        </div>
      </div>
    )

    shipScheduleContent.push(
      <div className="work-scheduled-item__info">
        <b>Thành viên tham gia: </b>
        <div>
          {workScheduled.attenders ? (
            workScheduled.attenders
          ) : (
            <EmptyText>Không có thành viên tham gia.</EmptyText>
          )}
        </div>
      </div>
    )

    return shipScheduleContent
  }

  const handleOk = async values => {
    setConfirmLoading(true)
    try {
      const response = await authenticationStore.userLogin(
        values.identifier,
        values.password
      )
      if (response.status === 200) {
        const {
          data: { name_uppercase: nameInUppercase, username },
        } = await authenticationStore.checkCurrentUser()
        console.log('[INFO]  nameInUppercase:', nameInUppercase)
        message.success(
          `Xin chào, ${utils.getNameInCapitalize(nameInUppercase)}!`
        )
        await Promise.allSettled([
          authenticationStore.getCurrentUserAvatar(),
          commandStore.getCommandList(),
          notificationStore.getUnreadNotificationCount(),
          notificationStore.getUnreadNewsCount(),
          userStore.getMentionUserList(),
          accountStore.getCurrentUserAccount(),
          moduleStore.getModuleList(),
          aclStore.getACLDetailByUser(username),
        ])
        setShowDialog(false)
      }
    } catch (err) {
      console.log('[INFO]  err:', err)
    } finally {
      setConfirmLoading(false)
    }
  }

  const loginPage = (
    <>
      <LoginWrapper
        bgImage={`${process.env.PUBLIC_URL}/assets/photos/auth-bg-2.jpg`}>
        {useSSO ? (
          <></>
        ) : (
          <Form layout={'vertical'} name={'loginForm'} onFinish={handleOk}>
            <Form.Item style={{ textAlign: 'center' }}>
              <img
                alt="login_logo"
                height={32}
                src={`${process.env.PUBLIC_URL}/assets/photos/portal_logo_white.png`}
              />
            </Form.Item>
            <Form.Item
              label="Tên đăng nhập"
              name="identifier"
              rules={[
                { required: true, message: 'Vui lòng nhập tên đăng nhập!' },
                { validator: validator.validateUsername },
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              label="Mật khẩu"
              name="password"
              rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
              <Input.Password />
            </Form.Item>
            <Button
              type={'primary'}
              block
              htmlType={'submit'}
              loading={confirmLoading}
            // onClick={visibleLoading}
            >
              {' '}
              Đăng nhập
            </Button>

            <Button style={{ marginTop: 8 }} type={'link'} block>
              {' '}
              Quên mật khẩu?
            </Button>
            {/*<Button style={{ marginTop: 0 }} type={'link'} block onClick={showModal}> Lịch cơ quan</Button>*/}
          </Form>
        )}
      </LoginWrapper>
    </>
  )

  // const updatePassword = (
  //   <Modal
  //     title="Mật khẩu của bạn đã quá hạn!"
  //     onCancel={() => setMustChangePassword}
  //     className="ant-modal-custom"
  //     visible={mustChangePassword}>
  //     <Row align="middle">
  //       <Col className="gutter-row" span={24} offset={4}>
  //         <ChangePassword
  //           onAfterPasswordChanged={setMustChangePassword}
  //           visible={true}
  //           onCancel={setMustChangePassword}
  //         />
  //       </Col>
  //     </Row>
  //   </Modal>
  // )

  const topBlock = (
    <RowWrapper>
      <CardWrapper>
        {isAccessControl(
          MODULE_CODE.van_ban_noi_bo,
          ACL_ACTION_TYPE.menu__INTERNAL_DOCUMENT
        ) && (
            <CounterCard
              title={'Văn bản đến chưa đọc'}
              counter={dashboardSideMenuCounter?.unread_incoming ?? 0}
              icon={`${process.env.PUBLIC_URL}/assets/icons/document_outgoing_new.svg`}
              onClick={onClickIncoming}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoadingSidemenuCounter}
                backGround={'#ffffffc7'}
              />
            </CounterCard>
          )}

        {isAccessControl(
          MODULE_CODE.van_ban_noi_bo,
          ACL_ACTION_TYPE.menu__INTERNAL_DOCUMENT
        ) && (
            <CounterCard
              title={'Văn bản đi chưa đọc'}
              counter={dashboardSideMenuCounter?.unread_outgoing ?? 0}
              icon={`${process.env.PUBLIC_URL}/assets/icons/document_incoming_new.svg`}
              onClick={onClickOutgoing}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoadingSidemenuCounter}
                backGround={'#ffffffc7'}
              />
            </CounterCard>
          )}
        {isAccessControl(MODULE_CODE.cong_viec, ACL_ACTION_TYPE.menu__WORK) && (
          <CounterCard
            title={'Công việc chưa đọc'}
            counter={dashboardSideMenuCounter?.work ?? 0}
            icon={`${process.env.PUBLIC_URL}/assets/icons/work_manager_draft.svg`}
            onClick={onClickWorks}>
            <SpinnerInlineComponent
              sizeSpin={'small'}
              isLoading={isLoadingSidemenuCounter}
              backGround={'#ffffffc7'}
            />
          </CounterCard>
        )}
        {/* 
                tạm thời cmt
                {isAccessControl(
                  MODULE_CODE.nhiem_vu,
                  ACL_ACTION_TYPE.menu__MISSION
                ) && (
                  <CounterCard
                    title={'Nhiệm vụ quá hạn'}
                    counter={dashboardSideMenuCounter?.overdue_task ?? 0}
                    icon={`${process.env.PUBLIC_URL}/assets/icons/work_manager_overdue.svg`}
                    onClick={onClickMission}>
                    <SpinnerInlineComponent
                      sizeSpin={'small'}
                      isLoading={isLoadingSidemenuCounter}
                      backGround={'#ffffffc7'}
                    />
                  </CounterCard>
                )} */}
        {isAccessControl(
          MODULE_CODE.hanh_chinh,
          ACL_ACTION_TYPE.menu__PROPOSAL
        ) && (
            <CounterCard
              title={'Đơn hành chính chờ duyệt'}
              counter={dashboardSideMenuCounter?.proposal_other ?? 0}
              icon={`${process.env.PUBLIC_URL}/assets/icons/work_manager_processing.svg`}
              onClick={onClickProposal}>
              <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoadingSidemenuCounter}
                backGround={'#ffffffc7'}
              />
            </CounterCard>
          )}
      </CardWrapper>
      {isAccessControl(
        MODULE_CODE.thong_bao_chung,
        ACL_ACTION_TYPE.menu__NEWS
      ) && (
          <GeneralNotif
            header={<div>Thông báo chung </div>}
            footer={false}
            bordered
            dataSource={newsList.slice(0, 4)}
            renderItem={item => (
              <List.Item
                key={item.id}
                onClick={() => {
                  history.push(`/utility/general-notifications/view/${item.id}`)
                }}>
                {item.subject}
              </List.Item>
            )}>
            <SpinnerInlineComponent
              sizeSpin={'small'}
              isLoading={isLoadingTinTuc}
              backGround={'#ffffffc7'}
              tip={'Đang tải thông báo chung...'}
            />
          </GeneralNotif>
        )}
    </RowWrapper>
  )

  const iFrame = (
    <iframe
      title="TONG QUAN "
      width="100%"
      height="300"
      src={linkMisbi}
      frameBorder={0}
      allowFullScreen={true}></iframe>
  )

  return (
    <div>
      {currentUser != null ? (
        <DashboardLayout
          title={'Link People - Link the World'}
          backgroundColor={'#f2f3f8'}>
          <Helmet>
            <title>Dashboard | {systemName} Portal</title>
          </Helmet>
          <div style={{ position: 'relative' }}>
            {systemName == 'VIMC' ? iFrame : topBlock}
            {isAccessControl(
              MODULE_CODE.lich_co_quan,
              ACL_ACTION_TYPE.menu__WORK_SCHEDULE
            ) && (
                <>
                  <Spin spinning={isLoadingWorkSchedule}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 16,
                      }}>
                      <p style={{ fontWeight: 600, fontSize: 20, margin: 0 }}>
                        Lịch ngày
                      </p>
                      <DatePicker
                        allowClear={false}
                        picker="week"
                        onChange={date =>
                          setSelectedDate(date?.format(ISO_DATE_FORMAT))
                        }
                        placeholder={'Chọn tuần'}
                        format={date => `Tuần ${date.isoWeek()}, ${date.year()}`}
                        value={moment(selectedDate)}
                        style={{
                          height: 32,
                          width: 175,
                          margin: '0 10px 0 10px',
                        }}
                      />

                    </div>
                    <OfficeCalendar
                      selectedDate={selectedDate}
                      data={workScheduleListData}
                      selectedEventId={selectedEvent?.id}
                      onEventClick={setSelectedEvent}
                      isShowPopoverContent
                      onChangeDate={date => setSelectedDate(date?.format(ISO_DATE_FORMAT))}
                    />
                  </Spin>
                </>
              )}
            {/* {updatePassword} */}
          </div>
        </DashboardLayout>
      ) : (
        loginPage
      )}
    </div>
  )
}

export default memo(
  inject(
    'loadingAnimationStore',
    'commonStore',
    'statisticStore',
    'fileStore',
    'authenticationStore',
    'accountStore',
    'userStore',
    'companyStore',
    'notificationStore',
    'commandStore',
    'taskManagementStore',
    'taskManagementCommentStore',
    'moduleStore',
    'tintucStore',
    'aclStore',
    'infoOptionStore'
  )(observer(DashboardPageV2))
)
